<template>
    <div class="booking-edit-page-root" v-show="('bookingId' in Info)" style="margin: 0; font-size: 1rem;" :view-only="!Writable" @focusin="focused">
        <h2>利用予約</h2>

        <div style="margin-top: 1rem; font-size: 1.2rem">
            <RadioSelect v-if="IsCreate" :value="1" :options="[[1,'仮予約']]" />
            <RadioSelect v-else v-model="Info.bookingState" :options="[[1,'仮予約'], [2,'本予約' + (PrevBookingState==1 ? 'へ進む' : '')]]"
                @input="gotoFinal()" />
        </div>

        <AttentionLabel class="caption" text="利用日時" />
        <div readonly style="font-size: 1.2rem">{{formatDate(Info.bookingDate,'yyyy年M月d日', '-')}} {{formatTime(Info.bookingTime, '-')}}</div>

        <template v-if="!IsCreate">
            <AttentionLabel text="予約番号" />
            <div>{{Info.bookingCode}}</div>
        </template>

        <AttentionLabel text="予約者区分" :error="Error.holderType" />
        <RadioSelect v-model="Info.holderType" :options="[[1,'登録葬祭業者'], [2,'未登録']]"
            :disabled="!IsOperator || !IsCreate" />

        <template v-if="isTarget('companyId')">
            <AttentionLabel text="葬祭業者名" :error="Error.companyId" />
            <select v-model="Info.companyId" :disabled="!IsOperator || !IsCreate" style="overflow: hidden; max-width: 100%">
                <option :value="0"></option>
                <option v-for="x in Companys" :value="x.companyId" :key="x.compnayId" :disabled="x.disabled==1">
                    {{ x.companyName }}
                </option>
            </select>
        </template>

        <template v-if="isTarget('holderName')">
            <AttentionLabel text="予約者名" sub="[必須入力]" :error="Error.holderName" />
            <input v-model="Info.holderName" style="width: 200px" maxlength="64" />
        </template>
            
        <template v-if="isTarget('holderTel')">
            <AttentionLabel text="連絡先" sub="[必須入力]" :error="Error.holderTel" />
            <input v-model="Info.holderTel" style="width: 200px" maxlength="64" />
        </template>

        <template v-if="isTarget('useFacility1')">
            <AttentionLabel text="お別れ室" sub="[必須選択]" :error="Error.useFacility1" />
            <RadioSelect v-model="Info.useFacility1" :options="Selections.userFacility1()"  />
        </template>
        <template v-if="Info.useFacility1==2">
            <div style="font-weight: bold;">お別れ室の利用は火葬の1時間前（{{formatTime(Info.bookingTime-60)}}）からです。</div>
            <BookingEditPageFacilityPanel1 :date="Info.bookingDate" :time="Info.bookingTime" style="margin-top: 14px" />
        </template>

        <template v-if="isTarget('useFacility2')">
            <AttentionLabel text="霊安室" sub="[必須選択]" :error="Error.useFacility2" />
            <RadioSelect v-model="Info.useFacility2" :options="Selections.userFacility2()" />
        </template>

        <template v-if="isTarget('useFacility2Start')">
            <div v-if="Info.useFacility2 == 2" style="display: flex; gap: 3px; align-items:center; margin-top: 10px">
                <DatePicker v-model="Info.useFacility2Start" format="yyyy年MM月dd日" :max="Info.bookingDate" />
                から火葬当日まで
                <!-- <DatePicker :disabled="true" v-model="Info.useFacility2End" format="yyyy年MM月dd日" :max="Info.bookingDate" position="top: 28px; right:0" /> -->
            </div>
            <div style="font-weight: bold; margin-top: 0.25rem;">霊安室の入室予定時刻を特記事項欄へ記載をお願いします。</div>
            <BookingEditPageFacilityPanel2 :start="Info.createOn" :end="Info.bookingDate" style="margin-top: 14px" />
        </template>

        <div v-if="!IsCreate">
            <div style="margin-top: 2rem;">登録：{{ Info.createUser }}</div>
            <div>{{ formatDate(Info.createOn, 'yyyy/MM/dd HH:mm') }}</div>

            <div style="margin-top: 1rem;">更新：{{ Info.updateUser }}</div>
            <div>{{ formatDate(Info.updateOn, 'yyyy/MM/dd HH:mm') }}</div>
        </div>

        <!-- ////////////////////////////////////////////////////// -->

        <h2>利用者情報</h2>

        <div style="font-size: 0.9rem; margin-top: 5px;">
            故人の情報を入力します。<br />
            (身体の一部等：利用者の情報を入力します)<br />
            (死胎：母または父の情報を入力します)
        </div>

        <AttentionLabel text="利用区分" sub="[必須選択]" />
        <select v-model="Info.infoType">
            <option v-for="x in Selections.infoType()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
        </select>

        <AttentionLabel text="利用者名（カナ／漢字）" sub="[必須入力]" :error="Error.infoKana1" />
        <div style="display: flex; gap: 2px;">
            <input v-model="Info.infoKana1" maxlength="16" style="width: 140px;" placeholder="セイ" />
            <input v-model="Info.infoKana2" maxlength="16" style="width: 140px;" placeholder="メイ"  />
        </div>
        <AttentionLabel text="" :error="Error.infoName1" style="margin-top:5px" />
        <div style="display: flex; gap: 2px;">
            <input class="j-mincho" v-model="Info.infoName1" maxlength="16" style="width: 140px;" placeholder="姓" />
            <input class="j-mincho" v-model="Info.infoName2" maxlength="16" style="width: 140px;" placeholder="名" />
        </div>

        <template v-if="isTarget('infoExName') && isFinal()">
            <CheckButton v-model="Info.infoExName" style="margin-top: 12px">常用外漢字が含まれる</CheckButton>
            <div class="annot" style="margin:0">利用者名に入力できない漢字がある場合はチェックを付けて参考画像を添付します。<a v-if="IsOperator" href="/how-ivs.html" target="_blank">異体字の入力について</a></div>
            <div class="annot">文字により対応できない場合もございます。また一部の文字はWebページ上で正確に表示されない場合があります。</div>

            <template v-if="Info.infoExName==1">
                <button v-if="Info.existInfoNameExImage" class="attached-file-button" @click="downloadImage('info-name-ex')">
                    <svg yu-icon="download" size="18"></svg>登録された画像
                </button>
                <div v-else>登録されていません</div>
                <PictureSelect ref="info-name-ex-picture" :max-size="500" :disabled="!Writable" style="margin-top:10px"  />
            </template>
        </template>

        <template v-if="isTarget('infoFatherKana1') && isFinal()">
            <AttentionLabel text="父の名（カナ／漢字）" :error="Error.infoFatherKana1" />
            <div style="display: flex; gap: 2px;">
                <input v-model="Info.infoFatherKana1" maxlength="16" style="width: 140px;" placeholder="セイ" />
                <input v-model="Info.infoFatherKana2" maxlength="16" style="width: 140px;" placeholder="メイ" />
            </div>
            <AttentionLabel text="" :error="Error.infoFatherName1" style="margin-top:5px" />
            <div style="display: flex; gap: 2px;">
                <input class="j-mincho" v-model="Info.infoFatherName1" maxlength="16" style="width: 140px;" placeholder="姓" />
                <input class="j-mincho" v-model="Info.infoFatherName2" maxlength="16" style="width: 140px;" placeholder="名" />
            </div>
        </template>

        <template v-if="isTarget('infoMotherKana1') && isFinal()">
            <AttentionLabel text="母の名（カナ／漢字）" :error="Error.infoMotherKana1" />
            <div style="display: flex; gap: 2px;">
                <input v-model="Info.infoMotherKana1" maxlength="16" style="width: 140px;" placeholder="セイ" />
                <input v-model="Info.infoMotherKana2" maxlength="16" style="width: 140px;" placeholder="メイ" />
            </div>
            <AttentionLabel text="" :error="Error.infoMotherName1" style="margin-top:5px" />
            <div style="display: flex; gap: 2px;">
                <input class="j-mincho" v-model="Info.infoMotherName1" maxlength="16" style="width: 140px;" placeholder="姓" />
                <input class="j-mincho" v-model="Info.infoMotherName2" maxlength="16" style="width: 140px;" placeholder="名" />
            </div>
        </template>
                
        <template v-if="isTarget('infoBarthDateFlag')">
            <AttentionLabel text="生年月日" sub="[必須選択]" :error="Error.infoBarthDate" />
            <RadioSelect v-model="Info.infoBarthDateFlag" :options="[[0,'入力'], [1,'不詳']]" style="margin: 0 0 10px 0" />
        </template>
        
        <template v-if="isTarget('infoBarthDate')">
            <WarekiDateSelect v-model="Info.infoBarthDate" :warekis="Warekis"
                :maxYear="Info.bookingDate.getFullYear()" />
        </template>
        
        <template v-if="isTarget('infoAge') && isFinal()">
            <AttentionLabel text="年齢" sub="[必須選択]" :error="Error.infoAge" />
            <select v-model="Info.infoAge">
                <option v-for="x in Selections.infoAge()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
            </select>
        </template>

        <template v-if="isTarget('infoPregnancy') && isFinal()">
            <AttentionLabel text="妊娠月数または週数" sub="[必須選択]" :error="Error.infoPregnancy" />
            <div class="annot">～ヵ月または～週から選択してください</div>
            <select v-model="Info.infoPregnancy">
                <option v-for="x in Selections.infoPregnancy()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
            </select>
        </template>

        <template v-if="isTarget('infoSex') && isFinal()">
            <AttentionLabel text="性別" sub="[必須選択]" :error="Error.infoSex" />
            <RadioSelect v-model="Info.infoSex" :options="Selections.infoSex()" />
        </template>

        <template v-if="isTarget('infoAreaId')">
            <AttentionLabel text="住所の市区分" sub="[必須選択]" :error="Error.infoAreaId" />
            <select v-model="Info.infoAreaId">
                <option :value="0"></option>
                <option v-for="x in Areas" :value="x.areaId" :key="x.areaId">
                    {{ x.areaName }}
                </option>
            </select>
        </template>
        
        <template v-if="isTarget('infoAddress')">
            <AttentionLabel text="住所" sub="[必須入力]" :error="Error.infoAddress" />
            <StretchTextarea v-model="Info.infoAddress" rows="1" maxlength="300" :accept-wrap="false" class="in-textarea" style="width: 300px;" />
        </template>

        <template v-if="isTarget('infoDomicile') && isFinal()">
            <AttentionLabel text="本籍" sub="[必須入力]" :error="Error.infoDomicile" />
            <StretchTextarea v-model="Info.infoDomicile" rows="1" maxlength="300" :accept-wrap="false" class="in-textarea" style="width: 300px;" />
        </template>

        <template v-if="isTarget('infoDeathDateFlag')">
            <AttentionLabel text="死亡日（死胎：分娩日／身体の一部等：手術日）" sub="[必須選択]" :error="Error.infoDeathDate" />
            <RadioSelect v-model="Info.infoDeathDateFlag" :options="[[0,'入力'], [1,'不詳']]" style="margin: 0 0 10px 0" />
        </template>

        <template v-if="isTarget('infoDeathDate')">
            <WarekiDateSelect v-model="Info.infoDeathDate" :warekis="Warekis"
                :maxYear="Info.bookingDate.getFullYear()" />
        </template>

        <template v-if="isTarget('infoDeathTimeFlag')">
            <AttentionLabel text="死亡時刻（死胎：分娩時刻／身体の一部等：手術時刻）" sub="[必須選択]" :error="Error.infoDeathTime" />
            <RadioSelect v-model="Info.infoDeathTimeFlag" :options="[[0,'入力'], [1,'不詳']]" style="margin: 0 0 10px 0" />
        </template>

        <template v-if="isTarget('infoDeathTime')">
            <TimeSelect v-model="Info.infoDeathTime" />
        </template>
        
        <template v-if="isTarget('infoDeathAreaId') && isFinal()">
            <AttentionLabel text="死亡場所の市区分（死胎：分娩場所／身体の一部等：手術場所）" sub="[必須選択]" :error="Error.infoDeathAreaId" />
            <select v-model="Info.infoDeathAreaId">
                <option :value="0"></option>
                <option v-for="x in Areas" :value="x.areaId" :key="x.areaId">
                    {{ x.areaName }}
                </option>
            </select>
        </template>

        <template v-if="isTarget('infoDeathLocation') && isFinal()">
            <AttentionLabel text="死亡場所（死胎：分娩場所／身体の一部等：手術場所）" sub="[必須入力]" :error="Error.infoDeathLocation" />
            <input v-model="Info.infoDeathLocation" maxlength="300" style="width: 300px;" />
        </template>

        <template v-if="isTarget('infoReportAreaId')">
            <AttentionLabel text="死亡届の届出先" sub="[必須選択]" :error="Error.infoReportAreaId" />
            <select v-model="Info.infoReportAreaId">
                <option :value="0"></option>
                <option v-for="x in Areas" :value="x.areaId" :key="x.areaId">
                    {{ x.areaName }}
                </option>
            </select>
        </template>

        <template v-if="isTarget('infoSpacialCase1') && isFinal()">
            <AttentionLabel text="死因" sub="[必須選択]" :error="Error.infoSpacialCase1" />
            <RadioSelect v-model="Info.infoSpacialCase1"  :options="Selections.infoSpacialCase1()" />
        </template>

        <template v-if="isTarget('infoSpacialCase2') && isFinal()">
            <AttentionLabel text="ペースメーカー" sub="[必須選択]" :error="Error.infoSpacialCase2" />
            <RadioSelect v-model="Info.infoSpacialCase2" :options="Selections.infoSpacialCase2()" />
        </template>
            
        <template v-if="isTarget('infoComeFrom') && isFinal()">
            <AttentionLabel text="出棺場所" :error="Error.infoComeFrom" />
            <input v-model="Info.infoComeFrom" maxlength="300" style="width: 300px;" />
        </template>
        
        <template v-if="isTarget('infoWeight') && isFinal()">
            <AttentionLabel text="棺を含めた総重量" sub="[必須選択]" :error="Error.infoWeight" />
            <select v-model="Info.infoWeight">
                <option v-for="x in Selections.infoWeight()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
            </select>
        </template>

        <!-- ////////////////////////////////////////////////////// -->

        <template v-if="isFinal()">
            <h2>申請者情報</h2>

            <template v-if="isTarget('ownerKana1')">
                <AttentionLabel text="申請者名（カナ／漢字）" sub="[必須入力]" :error="Error.ownerKana1" />
                <div style="display: flex; gap: 2px;">
                    <input v-model="Info.ownerKana1" maxlength="16" style="width: 140px;" placeholder="セイ" />
                    <input v-model="Info.ownerKana2" maxlength="16" style="width: 140px;" placeholder="メイ" />
                </div>
                <AttentionLabel text="" :error="Error.ownerName1" style="margin-top:5px" />
                <div style="display: flex; gap: 2px;">
                    <input class="j-mincho" v-model="Info.ownerName1" maxlength="16" style="width: 140px;" placeholder="姓" />
                    <input class="j-mincho" v-model="Info.ownerName2" maxlength="16" style="width: 140px;" placeholder="名" />
                </div>
            </template>

            <template v-if="isTarget('ownerAreaId')">
                <AttentionLabel text="申請者住所の市区分" sub="[必須選択]" :error="Error.ownerAreaId" />
                <select v-model="Info.ownerAreaId">
                    <option :value="0"></option>
                    <option v-for="x in Areas" :value="x.areaId" :key="x.areaId">
                        {{ x.areaName }}
                    </option>
                </select>
            </template>

            <template v-if="isTarget('ownerAddress')">
                <AttentionLabel text="申請者住所" sub="[必須入力]" :error="Error.ownerAddress" />
                <StretchTextarea v-model="Info.ownerAddress" rows="1" maxlength="300" :accept-wrap="false" class="in-textarea" style="width: 300px;" />
            </template>

            <template v-if="isTarget('ownerRelation')">
                <AttentionLabel text="続柄（故人から見た申請者の続柄）" sub="[必須入力]" :error="Error.ownerRelation" />
                <input v-model="Info.ownerRelation" maxlength="16" style="width: 100px;" />
            </template>
        </template>

        <!-- ////////////////////////////////////////////////////// -->
        
        <template v-if="isFinal()">
            <h2>きみさらず聖苑 利用情報</h2>

            <template v-if="isTarget('mournerCount')">
                <AttentionLabel text="会葬者人数" :error="Error.mournerCount" />
                <div class="annot">おおよその会葬者人数を入力してください。</div>
                <select v-model="Info.mournerCount">
                    <option v-for="x in Selections.mournerCount()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
                </select>
            </template>
            
            <template v-if="isTarget('useWaitingRoom')">
                <AttentionLabel text="待合室の利用" :error="Error.useWaitingRoom" />
                <RadioSelect v-model="Info.useWaitingRoom" :options="Selections.useWaitingRoom()"  />
            </template>

            <template v-if="isTarget('useWaitingRoom')">
                <AttentionLabel text="きみさらず聖苑内の案内表示" :error="Error.usePlate" />
                <div class="annot">利用者名と異なる表示を希望する場合は[指定する]を選択します。</div>
                <RadioSelect v-model="Info.usePlate" :options="Selections.usePlate()"  />
            </template>
            
            <template v-if="isTarget('plateExName1')">
                <AttentionLabel :error="Error.plateExName1" sub="[必須入力]" style="margin-top: 12px" />
                <div style="display: flex; gap: 2px;">
                    <input class="j-mincho" v-model="Info.plateExName1" maxlength="16" style="width: 140px;" placeholder="姓" />
                    <input class="j-mincho" v-model="Info.plateExName2" maxlength="16" style="width: 140px;" placeholder="名" />
                </div>
            </template>
            
            <template v-if="isTarget('platePrefix')">
                <AttentionLabel text="案内表示の敬称" :error="Error.platePrefix" />
                <select v-model="Info.platePrefix">
                    <option v-for="x in Selections.platePrefix()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
                </select>
            </template>

            <template v-if="isTarget('useAnnounce')">
                <AttentionLabel text="きみさらず聖苑内の館内放送" :error="Error.useAnnounce" />
                <div class="annot">館内放送で収骨の案内を希望する場合は[放送あり]を選択します。</div>
                <RadioSelect v-model="Info.useAnnounce" :options="Selections.useAnnounce()"  />
            </template>

            <template v-if="isTarget('announceName')">
                <AttentionLabel text="館内放送の名前" :error="Error.announceName" sub="[必須入力]" />
                <div class="annot">〇〇家様とお呼びします家や様を省いて入力してください。</div>
                <input v-model="Info.announceName" maxlength="32" style="width: 100px;" placeholder="セイ" />
            </template>

            <template v-if="isTarget('religion')">
                <AttentionLabel text="宗派" sub="[必須選択]" :error="Error.religion" />
                <div class="annot">その他を選択した場合は特記事項欄に入力してください。</div>
                <select v-model="Info.religion">
                    <option v-for="x in Selections.religion()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
                </select>
            </template>
            
        </template>

        <h2>特記事項</h2>
        
        <template v-if="isTarget('infoMemo')">
            <AttentionLabel text="特記事項" :error="Error.infoMemo" />
            <StretchTextarea v-model="Info.infoMemo" maxlength="300" rows="1" :acceptWrap="false" class="in-textarea" style="width: 300px;" />
        </template>

        <template v-if="isTarget('infoCremationPermit') && isFinal()">
            <AttentionLabel text="火葬許可証（改葬遺骨：改葬許可証／身体の一部等：医師の診断書）" sub="[必須選択]" :error="Error.infoCremationPermit" />
            <div class="annot">カメラで撮影または取り込んだ画像を添付します。</div>
            <RadioSelect v-model="Info.infoCremationPermit" :options="Selections.infoCremationPermit()" />

            <div v-if="Info.infoCremationPermit==1" style="margin-top: 5px;">
                <button v-if="Info.existCremationPermitImage" @click="downloadImage('cremation-permit')" class="attached-file-button">
                    <svg yu-icon="download" size="18"></svg>登録された画像
                </button>
                <div v-else>登録されていません</div>
                <PictureSelect ref="cremation-permit-picture" :max-size="3000" :disabled="!Writable" style="margin-top: 10px" />
            </div>
        </template>

        <!-- ////////////////////////////////////////////////////// -->
        
        <template v-if="IsOperator && PrevBookingState == 2">
            <h2>管理情報</h2>
            <AttentionLabel text="減免" />
            <RadioSelect v-model="Info.exempted" :options="[[1,'あり'], [0,'なし']]"  />

            <template v-if="isTarget('useFacility2StartTime')">
                <AttentionLabel text="霊安室受付時刻" />
                <TimeSelect v-model="Info.useFacility2StartTime" :nullable="false" />
            </template>
            
            <AttentionLabel text="火葬執行時刻" />
            <TimeSelect v-model="Info.executionTime" :nullable="false" />

            <AttentionLabel text="火葬済証明書の発行数" />
            <select v-model="Info.certificates1">
                <option v-for="i of 10" :key="i" :value="i-1">{{i-1}}</option>
            </select>
            
            <AttentionLabel text="分骨証明書の発行数" />
            <select v-model="Info.certificates2">
                <option v-for="i of 10" :key="i" :value="i-1">{{i-1}}</option>
            </select>
            
            <AttentionLabel text="収納日" :error="Error.receiptDate" />
            <DatePicker v-model="Info.receiptDate" format="yyyy年MM月dd日" position="bottom: 28px; left: 0;" style="width: 150px" />
        </template>

        <div style="border-top: 1px dashed lightgray; margin: 36px 0 16px 0;"></div>

        <div style="display: flex; gap: 62px; align-items: flex-end">
            <button v-if="Writable" style="width: 120px; height: 45px" @click="save">予約登録</button>
        </div>
    </div>
</template>

<script>
import Util from "../../assets/utility"
import { Auth } from "../../assets/auth"
import { Router } from "../../assets/router"
import { Dialog } from '../../assets/dialog'
import { CompanyController } from "../../assets/api/companyController.js"
import { BookingController } from "../../assets/api/bookingController"
import { MasterController } from "../../assets/api/masterController.js"
import { BookingInfoSelections, IsTargetData } from "../../assets/bookingInfoOptions.js"

import RadioSelect from "../../components/RadioSelect.vue"
import AttentionLabel from "../../components/AttentionLabel.vue"
import DatePicker from "../../components/DatePicker.vue"
import StretchTextarea from "../../components/StretchTextarea.vue"
import WarekiDateSelect from "../../components/WarekiDateSelect.vue"
import TimeSelect from "../../components/TimeSelect.vue"
import CheckButton from "../../components/CheckButton.vue"
import PictureSelect from "../../components/PictureSelect.vue"
import BookingEditPageFacilityPanel2 from "./BookingEditPageFacilityPanel2.vue"
import BookingEditPageFacilityPanel1 from "./BookingEditPageFacilityPanel1.vue"
import "../../assets/api/tableTypes.js"

export default {
    components:{
        RadioSelect,
        AttentionLabel,
        DatePicker,
        StretchTextarea,
        WarekiDateSelect,
        TimeSelect,
        CheckButton,
        PictureSelect,
        BookingEditPageFacilityPanel1,
        BookingEditPageFacilityPanel2,
    },
    data(){
        return {
            /** ユーザーが運用かどうか */
            IsOperator: false,
            /** 新規作成かどうか */
            IsCreate: true,
            /** 変更前の予約状態 */
            PrevBookingState: 0,
            /** 変更可能か否か */
            Writable: true,

            /** @type {BookingDetail} */
            Info:{},

            /** 値チェックエラー */
            Error:{},

            /** @type {CompanyNameListData[]} */
            Companys:[],

            /** @type {MsWareki[]} */
            Warekis:[],

            /** @type {MsArea[]} */
            Areas:[],

            Selections: BookingInfoSelections(),

            Api:{
                company: new CompanyController(),
                master: new MasterController(),
                booking: new BookingController(),
            },
        }
    },
    async mounted(){
        window.scrollTo(0, 0)
        let acc = Auth.getAuthState()
        this.IsOperator = acc.role == 0

        let bookingId = Number(Router.getParameters().id)
        this.IsCreate = bookingId == 0

        Dialog.spinAsync()

        //マスタ
        let res = await Promise.all([
            this.Api.company.getNameList(),
            this.Api.master.getWarekiList(),
            this.Api.master.getAreaList(),
        ])
        if(res.some(x=>!x.ok)) return

        this.Companys = res[0].data
        this.Warekis = res[1].data
        this.Areas = res[2].data

        if(!this.IsCreate){        
            //編集
            let res = await this.Api.booking.getDetail(bookingId)
            if(!res.ok){
                await this.warning("予約情報を取得できませんでした。"
                    + (res.status==400 ? `\n${res.body}` : ""))
                history.back()                
            }
            this.Info = res.data
            this.PrevBookingState = res.data.bookingState

            if(this.PrevBookingState == 3){
                //仮押さえの編集は登録と同等
                this.IsCreate = true
                this.Info = this.createNewInfo(this.Info.bookingId, this.Info.bookingDate, this.Info.bookingTime, acc.companyId)
            }
        }else{
            //新規登録
            let query = Util.getUrlQuerys()
            this.Info = this.createNewInfo(0, new Date(Number(query.date)), Number(query.time), acc.companyId)
        }
        
        //編集可否
        this.Writable = this.IsOperator || this.PrevBookingState <= 1
        Dialog.close()
    },
    methods: {
        //初期データ作成
        createNewInfo(bookingId, bookingDate, bookingTime, companyId) {
            return {
                bookingDate : bookingDate,
                bookingTime : bookingTime,
                bookingId : bookingId,
                bookingCode : "",
                createUser : "",
                updateUser : "",
                createOn : new Date(),
                updateOn : new Date(),
                approved : 0,
                bookingState : 1,
                holderType: 1,
                companyId : companyId,
                holderName : "",
                holderTel : "",
                infoType : 1,
                infoName1 : "",
                infoName2 : "",
                infoKana1 : "",
                infoKana2 : "",
                infoExName : 0,
                infoBarthDateFlag : 0,
                infoBarthDate : Util.getNullDate(),
                infoAge : "",
                infoPregnancy : "",
                infoSex : 0,
                infoAreaId : 0,
                infoAddress : "",
                infoDomicile : "",
                infoDeathDateFlag : 0,
                infoDeathDate : Util.getNullDate(),
                infoDeathTimeFlag : 0,
                infoDeathTime : -1,
                infoDeathLocation : "",
                infoDeathAreaId : 0,
                infoReportAreaId : 0,
                infoSpacialCase1 : 1,
                infoSpacialCase2 : 1,
                infoWeight : "100kg未満",
                infoComeFrom : "",
                infoMemo : "",
                infoFatherName1 : "",
                infoFatherName2 : "",
                infoFatherKana1 : "",
                infoFatherKana2 : "",
                infoMotherName1 : "",
                infoMotherName2 : "",
                infoMotherKana1 : "",
                infoMotherKana2 : "",
                infoCremationPermit : 1,
                ownerName1 : "",
                ownerName2 : "",
                ownerKana1 : "",
                ownerKana2 : "",
                ownerAreaId : 0,
                ownerAddress : "",
                ownerRelation : "",
                mournerCount : "",
                useWaitingRoom : 2,
                usePlate : 2,
                plateExName1 : "",
                plateExName2 : "",
                platePrefix : "故",
                useAnnounce : 2,
                announceName : "",
                religion : 0,
                useFacility1 : 0,
                useFacility2 : 0,
                useFacility2Start : Util.addDate(bookingDate, -1),
                useFacility2End : Util.addDate(bookingDate, 0),
                useFacility2StartTime : 0,
                useFacility2EndTime : bookingTime,
                exempted : 0,
                certificates1 : 0,
                certificates2 : 0,
                executionTime : bookingTime,
                receiptDate : Util.addDate(bookingDate, 0),
            }
        },
        /** 登録 */
        async save(){
            this.resetUntargetData()
            if(this.check()){
                setTimeout(()=>Util.scroll(document.querySelector("[attention-label-error]").offsetTop - 80), 1)
                await this.warning("内容にエラーがあります。入力欄を確認してください。")
                return
            }

            let ok = await this.ask("現在の入力内容で予約を登録します。"
                + (!this.IsOperator && this.Info.bookingState == 2 ? "\n本予約後は葬祭業者から編集できません。" : ""))
            if(!ok) return

            Dialog.spinAsync()
            
            //画像添付
            this.Info.infoNameExImage = await this.$refs["info-name-ex-picture"]?.getBase64()
            this.Info.cremationPermitImage= await this.$refs["cremation-permit-picture"]?.getBase64()

            let res = this.IsCreate
                ? await this.Api.booking.create(this.Info)
                : await this.Api.booking.update(this.Info)
            Dialog.close()

            if(!res.ok){
                this.warning(`予約を登録できませんでした。`
                    + (res.status==400 ? `\n${res.body}` : ""))
            }else{
                await Dialog.messageboxAsync("予約を登録しました。",
                    Dialog.Messagebox_Buttons_Ok,
                    Dialog.Messagebox_Icon_Info)
                
                if(history.length > 2) history.back()
                else Router.navigateByKey("dashboard")
            }
        },
        /** 入力値のチェック */
        check(){
            let e = {}
            let x = this.Info

            //仮予約から
            if(ngNum1(x.infoType)){
                e.infoType = "選択してください。"
            }
            if(this.isTarget("companyId") && ngNum1(x.companyId)){
                e.companyId = "選択してください。"
            }
            if(this.isTarget("holderName") && ngStr(x.holderName)){
                e.holderName = "必須入力項目です。"
            }
            if(this.isTarget("holderTel") && ngStr(x.holderTel)){
                e.holderTel = "必須入力項目です。"
            }
            if(this.isTarget("infoName1") && (ngStr(x.infoName1) || ngStr(x.infoName2))){
                e.infoName1 = "必須入力項目です。"
            }
            if(this.isTarget("infoKana1") && (ngKana(x.infoKana1) || ngKana(x.infoKana2))){
                e.infoKana1 = "全角カナで入力してください。"
            }
            if(this.isTarget("infoBarthDate") && ngDate(x.infoBarthDate)){                
                e.infoBarthDate = "日付または不詳を選択してください。"
            }
            if(this.isTarget("infoAreaId") && ngNum1(x.infoAreaId)){
                e.infoAreaId = "選択してください。"
            }
            if(this.isTarget("infoAddress") && ngStr(x.infoAddress)){
                e.infoAddress = "必須入力項目です。"
            }
            if(this.isTarget("infoDeathDate") && ngDate(x.infoDeathDate)){                
                e.infoDeathDate = "日付または不詳を選択してください。"
            }
            if(this.isTarget("infoDeathTime") && ngTime(x.infoDeathTime)){                
                e.infoDeathTime = "時刻または不詳を選択してください。"
            }
            if(this.isTarget("infoReportAreaId") && ngNum1(x.infoReportAreaId)){
                e.infoReportAreaId = "選択してください。"
            }
            if(this.isTarget("useFacility1") && ngNum1(x.useFacility1)){
                e.useFacility1 = "選択してください。"
            }
            if(this.isTarget("useFacility2") && ngNum1(x.useFacility2)){
                e.useFacility2 = "選択してください。"
            }

            //本予約のみ
            if(x.bookingState == 2){
                if(this.isTarget("infoSex") && ngNum1(x.infoSex)){
                    e.infoSex = "選択してください。"
                }
                if(this.isTarget("infoDomicile") && ngStr(x.infoDomicile)){
                    e.infoDomicile = "必須入力項目です。"
                }
                if(this.isTarget("infoDeathAreaId") && ngNum1(x.infoDeathAreaId)){
                    e.infoDeathAreaId = "選択してください。"
                }
                if(this.isTarget("infoDeathLocation") && ngStr(x.infoDeathLocation)){
                    e.infoDeathLocation = "必須入力項目です。"
                }
                if(this.isTarget("infoWeight") && ngStr(x.infoWeight)){
                    e.infoWeight = "選択してください。"
                }
                if(this.isTarget("infoAge") && ngStr(x.infoAge)){
                    e.infoAge = "選択してください。"
                }
                if(this.isTarget("infoPregnancy") && ngStr(x.infoPregnancy)){
                    e.infoPregnancy = "選択してください。"
                }
                if(this.isTarget("ownerName1") && (ngStr(x.ownerName1) || ngStr(x.ownerName2))){
                    e.ownerName1 = "必須入力項目です。"
                }
                if(this.isTarget("ownerKana1") && (ngKana(x.ownerKana1) || ngKana(x.ownerKana2))){
                    e.ownerKana1 = "全角カナで入力してください。"
                }
                if(this.isTarget("ownerAreaId") && ngNum1(x.ownerAreaId)){
                    e.ownerAreaId = "選択してください。"
                }
                if(this.isTarget("ownerAddress") && ngStr(x.ownerAddress)){
                    e.ownerAddress = "必須入力項目です。"
                }
                if(this.isTarget("ownerRelation") && ngStr(x.ownerRelation)){
                    e.ownerRelation = "必須入力項目です。"
                }
                if(this.isTarget("plateExName1") && (ngStr(x.plateExName1) || ngStr(x.plateExName2))){
                    e.plateExName1 = "必須入力項目です。"
                }
                if(x.bookingDate.getTime() >= Util.getToday().getTime()){
                    //前日以前は削除されるている可能性があるためチェックしない
                    if(this.isTarget("religion") && ngNum1(x.religion)){
                        e.religion = "選択してください。"
                    }
                }
                if(this.isTarget("announceName") && ngKana(x.announceName)){
                    e.announceName = "全角カナで入力してください。"
                }
            }

            //死亡日時から24時間経っていること
            if(this.isTarget("infoDeathDate")
                && e.infoDeathDate==undefined && x.infoDeathDateFlag==0){

                let book = x.bookingDate.getTime() + x.bookingTime * 60 * 1000                
                let deth = x.infoDeathDate.getTime()
                if(e.infoDeathTime==undefined && x.infoDeathTimeFlag==0){
                     deth += x.infoDeathTime * 60 * 1000
                }

                if(book - deth < 24 * 60 * 60 * 1000){
                    e.infoDeathDate = "死亡日時から24時間未満の火葬は予約できません。"
                }
            }

            //画像ファイルの添付チェック
            if(!x.existCremationPermitImage
                && this.PrevBookingState == 1 //過去データの変更時は削除されている可能性があるので仮⇒本予約のときのみ
                && this.$refs["cremation-permit-picture"]?.existFile()==false){
                e.infoCremationPermit = "添付する画像を選択してください。"
            }

            this.Error = e
            return Object.keys(e).some(k=>e[k] != "")

            function ngNum1(v){
                if(v == null) return true
                if(v == undefined) return true
                if(v<=0) return true
                return false
            }
            function ngStr(v){
                if(v == null) return true
                if(v == undefined) return true
                if(v.trim() == "") return true
                return false
            }
            function ngKana(v){
                if(v == null) return true
                if(v == undefined) return true
                if(v.trim() == "") return true
                if(!/^[ァ-ヶー]+$/.test(v)) return true
                return false
            }
            function ngDate(v){
                if(v == null) return true
                if(v == undefined) return true
                if(v.getTime() == Util.getNullDate().getTime()) return true
                return false
            }
            function ngTime(v){
                if(v == null) return true
                if(v == undefined) return true
                if(v < 0) return true
                return false
            }
        },
        /** 情報対象外の項目を初期値にする */
        resetUntargetData(){
            let reset = this.createNewInfo(this.Info.bookingId, this.Info.bookingDate, this.Info.bookingTime)
            Object.keys(reset).forEach(k=>{
                this.Info[k] ??= reset[k] //null消し、一部のselectのバインドで未選択がnull/undefinedとなる
                if(!this.isTarget(k)) this.Info[k] = reset[k]
            })
        },
        isTarget(name){
            return IsTargetData(this.Info, name)
        },
        isFinal(){
            return this.Info.bookingState == 2
        },
        /** 画像ファイルダウンロード */
        async downloadImage(fname){
            Dialog.spinAsync()
            let res = await this.Api.booking.getImageData(this.Info.bookingId, fname)
            Dialog.close()
            if(!res.ok){
                this.warning("画像データを取得できません。")
                return
            }
            
            let url = window.URL.createObjectURL(res.body)

            let anchor = document.createElement("a")
            anchor.download = `${this.Info.bookingCode}-${fname}.jpg`
            anchor.href = url
            anchor.click()
            anchor.remove()
            setTimeout(() => window.URL.revokeObjectURL(url), 10000)
        },
        /** 参照専用時のフォーカス外し */
        focused(e){
            if(!this.Writable){
                document.activeElement.blur()
                e.preventDefault()
            }
        },
        async ask(msg){
            return await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_OkCancel,
                Dialog.Messagebox_Icon_Info)
        },
        async warning(msg){
            return await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_Ok,
                Dialog.Messagebox_Icon_Warn)
        },
        formatDate(d, fmt, nullval){
            if(!d) return nullval ?? ""
            return Util.formatDate(d, fmt)
        },
        formatTime(t, nullval){
            if(!t) return nullval ?? ""
            return Util.formatTime(t)
        },
        async gotoFinal(){
            if(this.PrevBookingState==1 && this.Info.bookingState == 2){
                await Dialog.messageboxAsync("本予約へ進みます。追加の情報を入力し登録してください。登録後は本予約となり葬祭業者から編集できません。",
                    Dialog.Messagebox_Buttons_Ok, Dialog.Messagebox_Icon_Info)
                Util.scroll(document.querySelectorAll("h2")[1].offsetTop - 80)
            }
        }
    },
}
</script>

<style>
.booking-edit-page-root textarea{
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
.booking-edit-page-root input,
.booking-edit-page-root textarea,
.booking-edit-page-root select{
    border: 1px solid #b4bdc5 !important;
    border-radius: 3px !important;
    background: #fcfdff !important;
}
</style>

<style scoped>
h2{
    font-weight: bold;
    color: dimgray;
    font-size: 1.3rem;
}
h2:nth-child(n+2){
    border-top: 1px dashed lightgray;
    margin-top: 36px;
    padding-top: 16px;
}
h2::before{
    content: "■ ";
    color: #95859c;
}
select,
input:not([type]),
.in-textarea {
    display: block;
}
input:read-only,
select:disabled{
    background: none !important;
    border: none !important;
    outline: none !important;
}
select{
    min-width: 80px;
}
select:disabled{
    color: inherit;
    border: none;
    appearance: none;
}
.annot{
    font-size: 0.9rem;
    color: gray;
    margin-bottom: 5px;
}
.annot::before{
    content: "※";
}
[view-only] * {
    pointer-events: none !important;
}
input.j-mincho{
    font-size: 1.4rem;
    padding-top: 2px;
    padding-bottom: 2px;
}
.attached-file-button{
    display:flex;
    align-items:center;
    gap: 2px;
    border: 0px solid gray;
    background: lavender;
    border-radius: 3px;
    padding: 4px 6px 4px 4px;
    pointer-events: all !important;
}
.attached-file-button:hover{
    text-decoration: underline;
}
.attached-file-button svg{
    color: lightslategray;
}
</style>